/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { greetingConditionTypeEnumSchema } from "../greetingConditionTypeEnumSchema.ts";
import { greetingModelPagedResultSchema } from "../greetingModelPagedResultSchema.ts";
import { z } from "zod";

export const getApiGreetingsQueryParamsSchema = z.object({
    "Conditions": z.array(z.lazy(() => greetingConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Everyday</b>: Ежедневно</li>\n<li><b>2 - OnDate</b>: На дату</li>\n<li><b>3 - OnPeriod</b>: На период</li>\n</ul>\n")).describe("Фильтр по условиям показа").optional(),
"IsActive": z.boolean().describe("Статус шаблонов").optional(),
"SortByName": z.boolean().describe("Сортировка по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по наименованию с конца").optional(),
"SortByDate": z.boolean().describe("Сортировка по дате").optional(),
"SortByDateDesc": z.boolean().describe("Сортировка по дате").optional(),
"SortByPriority": z.boolean().describe("Сортировка по приоритету").optional(),
"SortByPriorityDesc": z.boolean().describe("Сортировка по приоритету").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список шаблонов приветственных экранов
 */
export const getApiGreetings200Schema = z.lazy(() => greetingModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiGreetings400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiGreetings401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiGreetings403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiGreetings500Schema = z.lazy(() => badResponseModelSchema)

export const getApiGreetingsQueryResponseSchema = z.lazy(() => getApiGreetings200Schema)